<template>
  <div>
    <div class="wrapper">
      <breadcrumb
        :crumbs="[$t('menu.snapshoots'), $t('text.list')]"
      ></breadcrumb>
    </div>
    <div class="search">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <date
          v-model.trim="searchForm"
          type="month"
          field="snapDate"
          :placeholder="$t('text.month')"
        />
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <vxe-table
        :data="records"
        :loading="loading"
        id="snapshootsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column field="images" :title="$t('snapshoot.snapDate')">
          <template v-slot="{ row }">
            <router-link
              :to="{
                name: 'mmsSnapshootsShow',
                params: { snapDate: row.snapDate },
              }"
            >
              {{ snapDateAnalysis(row.snapDate) }}
            </router-link>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="materialQty"
          :title="$t('snapshoot.materialQty')"
        />
        <vxe-table-column
          field="quantity"
          :title="$t('snapshoot.quantityMms')"
        />
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips"></div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import { page, table } from "@/utils/mixins.js";
import Date from "@/components/Date";

import InventoriesSnapshootMms from "@/api/inventoriesSnapshootMms.js";

export default {
  mixins: [page, table.pager, table.search, table.sorter, table.basic],
  components: { Date },
  data() {
    return {};
  },
  created() {},
  methods: {
    snapDateAnalysis(snapDate) {
      if (snapDate == null) {
        return "";
      } else {
        return (
          snapDate.substring(0, 4) + "年" + snapDate.substring(4, 6) + "月"
        );
      }
    },
    //-----
    dataProvider(params) {
      return InventoriesSnapshootMms.search(params);
    },
  },
};
</script>
